<div class="log-list-expanded-content">
    <ng-content></ng-content>

    <cds-button
        size="sm"
        class="log-list-expanded-content__full-log-button"
        (click)="handleViewFullLog()"
    >
        <span class="log-list-expanded-content__full-log-button-label">
            {{ l10nKeys.viewFullLogLabel | vtranslate }}
        </span>
    </cds-button>
</div>
